export enum IFrameSizeEventType {
  HEIGHT = 'Height',
  WEB_CHAT_BOT_HEIGHT = 'web-chat-bot-height',
}

// Tech debt: this event should be posted on their corresponding web-apps
// WEB_LIVE_CLASS_ONBOARDING_HEIGHT = 'web-live-class-onboarding-height',
// WEB_MY_COACH_HEIGHT = 'web-my-coach-height',
// WEB_STUDY_PLAN_HEIGHT = 'web-study-plan-height',
